<template>
  <div class="taskListDetail">
    <div class="detial">
      <div class="detialLeft">
        <el-row>
          <el-col class="title" :span="6"> 任务名称： </el-col>
          <el-col :span="18">
            <span>{{ ruleForm.taskName }}</span>
          </el-col></el-row
        >
        <el-row>
          <el-col class="title" :span="6"> 任务状态： </el-col>
          <el-col :span="18">
            <span>{{ ruleForm.taskDetailsStateDict }}</span>
          </el-col></el-row
        >
        <el-row>
          <el-col class="title" :span="6"> 任务类型： </el-col>
          <el-col :span="18">
            <span>{{ ruleForm.taskTypeDict }}</span>
          </el-col></el-row
        >
        <el-row>
          <el-col class="title" :span="6"> 任务描述： </el-col>
          <el-col :span="18">
            <span>{{ ruleForm.taskDescribe }}</span>
          </el-col></el-row
        >
        <el-row>
          <el-col class="title" :span="6"> 巡防员： </el-col>
          <el-col :span="18">
            <span>{{ personnelInfo.join("、") }}</span>
          </el-col></el-row
        >
        <el-row>
          <el-col class="title" :span="6"> 上报内容： </el-col>
          <el-col :span="18">
            <el-button
              :type="!isPlay ? 'primary' : 'danger'"
              @click="mapReportOpenClose"
            >
              {{ isPlay ? "退出" : "播放" }}
            </el-button>
          </el-col></el-row
        >
      </div>
      <!-- <div class="detialRight">
        <div class="reportDetial" v-if="currentReport">
          <div class="detailInfo">
            <div
              style="margin-right: 8px"
              v-for="(item, index) in columns"
              :key="index"
            >
              <span>{{ item.label }}:</span>
              <span style="margin-left: 8px">{{
                currentReport[item.prop] ? currentReport[item.prop] : "--"
              }}</span>
            </div>
          </div>
          <div class="source">
            <div v-if="currentReport.img.length > 0">
              <h4>图片：</h4>
              <div class="source_item">
                <img
                  v-for="(item, index) in currentReport.img"
                  :key="index"
                  :src="fileIdSrc(item)"
                  @click="clickImg(item)"
                />
              </div>
            </div>

            <div v-if="currentReport.mp4.length > 0">
              <h4>视频：</h4>

              <div class="source_item">
                <video
                  v-for="(item, index) in currentReport.mp4"
                  :key="index"
                  :src="fileIdSrc(item)"
                  controls="controls"
                ></video>
              </div>
            </div>
            <div v-if="currentReport.mp3.length > 0">
              <h4>音频：</h4>

              <div class="source_item">
                <audio
                  v-for="(item, index) in currentReport.mp3"
                  :key="index"
                  :src="fileIdSrc(item)"
                  controls="controls"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="reportDetial">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in reportDetials"
            :key="index"
            :icon="item.icon"
            :type="item.type"
            :color="item.color"
            :size="item.size"
            :timestamp="item.reporterTime"
            placement="top"
          >
            <el-card @click="openMapReport(item, index)">
              <div style="margin-bottom: 12px">
                {{ item.reporterName + "_" + item.occupationDict }}
              </div>
              <div style="margin-bottom: 12px">
                {{ item.handleDescribe }}
              </div>
              <div class="source">
                <div v-if="item.img.length > 0">
                  <h4>图片：</h4>
                  <div class="source_item">
                    <img
                      v-for="(item, index) in item.img"
                      :key="index"
                      :src="fileIdSrc(item)"
                      @click="clickImg(item)"
                    />
                  </div>
                </div>
                <div v-if="item.mp4.length > 0">
                  <h4>视频：</h4>
                  <div class="source_item">
                    <video
                      v-for="(item, index) in item.mp4"
                      :key="index"
                      :src="fileIdSrc(item)"
                      controls="controls"
                    ></video>
                  </div>
                </div>
                <div v-if="item.mp3.length > 0">
                  <h4>音频：</h4>

                  <div class="source_item">
                    <audio
                      v-for="(item, index) in item.mp3"
                      :key="index"
                      :src="fileIdSrc(item)"
                      controls="controls"
                    ></audio>
                  </div>
                </div>

              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="mymap">
      <MyMap ref="mapRef" @loadMapSuccess="loadMap" />
    </div>
    <div class="openLine" v-if="showOpenMoveLine">
      <span @click="stopPlay"
        ><h-icon
          icon="icon-guanbi2"
          style="color: red; margin-right: 4px"
        ></h-icon
        >退出</span
      >
      <span @click="mapMoveLineOpenClose">
        <h-icon
          :icon="mapMoveLineOpen ? 'icon-zanting' : 'icon-zhibohuifang'"
        ></h-icon>
        {{ mapMoveLineOpen ? "暂停" : "播放" }}
      </span>
    </div>
    <h-big-picture
      :pictureUrl="pictureUrl"
      v-model:visible="bigPictureVisible"
    ></h-big-picture>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  nextTick,
  computed,
  onUnmounted,
} from "vue";
import { taskDetailsInfo } from "@/api/prevention/prevention.js";
import { patrolmanInfo, areaTrace } from "@/api/system/patrol";
import MyMap from "@/components/map/MyMap.vue";
import { ElMessage } from "element-plus";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
// import _ from "lodash";
export default defineComponent({
  components: { MyMap },
  props: {
    from: {
      type: Object,
      default: () => {},
    },
    occupationList: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      imgURL: window.imgURL,
      ruleForm: {
        taskName: "",
        taskStateDict: "1",
        taskTypeDict: "",
        taskDescribe: "",
      },
      columns: [
        {
          label: "上报人",
          prop: "reporterName",
        },
        {
          label: "上报时间",
          prop: "reporterTime",
        },
        {
          label: "职业",
          prop: "occupationDict",
        },
      ],
      imgURL: window.imgURL,
      mapLineOpen: false,
      reporterList: [],
      reporterIndex: 0,
      currentReport: null,
      patrolLine: null, // 巡防路径信息
      playReport: null, // 播放上报事件
      bigPictureVisible: false,
      pictureUrl: null,
      isPlay: false,
      patrolOccupationList: [],
      showOpenMoveLine: false, // 显示右下角播放退出
      mapMoveLineOpen: true, // 播放、暂停
      areaTraceList: [],
      personnelInfo: [],
      reportDetials: [
        // {
        //   content: "支持使用图标",
        //   timestamp: "2018-04-12 20:46",
        //   size: "large",
        //   type: "primary",
        //   color: "#666",
        //   img: [
        //     "/file/2022/09/15/72c85347559dabb9afaf5431e50eebe7.jpg",
        //     "/file/2022/09/15/72c85347559dabb9afaf5431e50eebe7.jpg",
        //   ],
        //   mp4: [],
        //   mp3: [],
        // },
      ],
    });
    const formRef = ref(null);
    const mapRef = ref();
    const { setPoint, reversePoint, BaiduToGPS, setVideoPoint } =
      handleCoordinates();
    watchEffect(() => {
      state.patrolOccupationList = props.occupationList;
      nextTick(() => {
        getTaskDetailsInfo();
      });
    });
    //获取巡防线路径
    const getpatrolIdInfo = async () => {
      let params = {
        id: props.from.patrolmanId,
      };
      const res = await patrolmanInfo(params);
      if (res.code == 0) {
        state.patrolLine = res.data;
        mapLineDrawArrow(state.patrolLine);
      }
    };
    getpatrolIdInfo();
    const getTaskDetailsInfo = async () => {
      let params = {
        id: props.from.taskDetailId,
      };
      const res = await taskDetailsInfo(params);
      if (res.code == 0) {
        state.ruleForm = res.data;
        // state.reporterList = res.data.list;
        handleReportDetials(res.data.list);
        state.personnelInfo = res.data.personnelInfoList.map((item) => {
          return item.name + "_" + item.occupationDict;
        });
      }
    };
    const changeFile = (val) => {
      if (val) return state.imgURL + val;
    };
    // 渲染巡防路径
    const mapLineDrawArrow = (tesk) => {
      if (!(tesk && tesk.patrolmanCoordinate)) return;
      let corrdinates = JSON.parse(tesk.patrolmanCoordinate);
      let polyline = corrdinates[0].map((element, index) => {
        return {
          name: tesk.patrolmanName,
          id: index,
          poiType: 3408,
          showMovePoint: false,
          showType: 3,
          speed: -45, // 移动速度
          info: {
            color: tesk.patrolmanColor,
            width: 12,
          },
          location: setVideoPoint([Number(element[0]), Number(element[1])]),
          click: (e) => {},
        };
      });
      mapRef.value && mapRef.value.mapLineArrow(polyline);
    };

    const loadMap = () => {
      setTimeout(() => {
        state.reporterList.forEach((elment) => {
          pushPoint(elment);
          handleMapLineNodeArr(state.reporterList);
        });
      }, 1000);
    };
    // 展示时间轴数据
    const handleReportDetials = (reportList) => {
      console.log(reportList, 666666666);
      if (reportList && reportList.length == 0) return;
      reportList.forEach((reportObj) => {
        let defaultobj = { size: "large", type: "primary", color: "#666" };
        let obj = { img: [], mp3: [], mp4: [] };
        reportObj.fileUrls &&
          reportObj.fileUrls.forEach((element) => {
            const type = element.split(".");
            if (type[1] == "png" || type[1] == "jpg") {
              obj.img.push(element);
            } else if (type[1] == "mp4") {
              obj.mp4.push(element);
            } else if (type[1] == "mp3") {
              obj.mp3.push(element);
            }
          });
        state.reportDetials.push({ ...defaultobj, ...reportObj, ...obj });
        console.log(obj);
      });
      console.log(state.reportDetials, 99999999999);
    };
    // 展示路径所有上报详情
    const handleMapLineNodeArr = (reportList) => {
      if (reportList && reportList.length == 0) return;
      state.currentReport = {};
      let obj = { img: [], mp3: [], mp4: [] };
      reportList.forEach((reportObj) => {
        reportObj.fileUrls &&
          reportObj.fileUrls.forEach((element) => {
            const type = element.split(".");
            if (type[1] == "png" || type[1] == "jpg") {
              obj.img.push(element);
            } else if (type[1] == "mp4") {
              obj.mp4.push(element);
            } else if (type[1] == "mp3") {
              obj.mp3.push(element);
            }
          });
      });
      state.currentReport = { ...reportList[0], ...obj };
      if (reportList[0].handleCoordinate) {
        const pos = JSON.parse(reportList[0].handleCoordinate);
        mapRef.value && mapRef.value.mapLocation(pos, 14.5);
      }
    };
    //播放
    const mapReportOpenClose = () => {
      state.isPlay = !state.isPlay;
      if (state.isPlay) {
        // state.reporterIndex = 0;
        state.showOpenMoveLine = true;
        openMapReport(state.reportDetials[0],0);
        playReportList(); //循环播放上报人上报点位
        getAreaTrace(); //播放上报人路径
      } else {
        clearInterval(state.playReport);
        state.showOpenMoveLine = false;
        stopPlay();
      }
    };

    const playReportList = () => {
      state.playReport = setInterval(() => {
        state.reporterIndex++;
        if (state.reporterIndex == state.reportDetials.length - 1) {
          clearInterval(state.playReport);
          setTimeout(() => {
            mapReportOpenClose();
            clearAreaTrace();
            mapRef.value && mapRef.value.clearPoint();
            state.isPlay = false;
            state.reportDetials.forEach((item) => {
              item.color = "#666";
            });
          }, 10000);
        }
        openMapReport(
          state.reportDetials[state.reporterIndex],
          state.reporterIndex
        );
      }, 5000);
    };

    // 展示路径单个上报详情
    const handleMapLineNode = (reportObj) => {
      if (!reportObj) return;
      reportObj.color = "#0bbd87";
      if (reportObj.handleCoordinate) {
        const pos = JSON.parse(reportObj.handleCoordinate);
        mapRef.value && mapRef.value.mapLocation(pos, 14.5);
      }
    };
    //地图放点
    const pushPoint = (data) => {
      if (!data.handleCoordinate) return;
      data.patrolmanColor = "red";
      const pointInfo = {
        name: `${data.reporterName}\n ${data.reporterTime} `,
        id: data.id,
        type: 1,
        showType: 3,
        poiType: 3418,
        location: JSON.parse(data.handleCoordinate),
        info: data,
        click: (e) => {
          handleMapLineNode(e[0].values_.info);
        },
      };
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker([pointInfo]);
      });
    };
    const fileIdSrc = (val) => {
      return val ? state.imgURL + val : "@/assets/images/moren.png";
    };
    // 图片点击
    const clickImg = (picUrl) => {
      state.pictureUrl = state.imgURL + picUrl;
      state.bigPictureVisible = true;
    };
    //根据任务获取巡防人轨迹
    const getAreaTrace = async (val) => {
      if (!state.ruleForm.taskDetailId) return;
      const param = {
        id: state.ruleForm.taskDetailId,
      };
      const res = await areaTrace(param);
      res.data[1].areaTraceList=[{id:5,anm:99}]
      state.areaTraceList = res.data && res.data.reduce((pre,next)=>{
        return pre.concat(next.areaTraceList)
      },[]);

      console.log(state.areaTraceList,99999999);
      if (!res.data) {
        state.areaTraceList = [];
        ElMessage.warning("暂无人员巡视轨迹！");
        return;
      }
      patrolMoveDraw(res.data[0]);
    };

    //巡防线分段绘制
    const patrolMoveDraw = async (obj) => {
      if (!obj || obj.areaTraceList.length == 0) return;
      state.patrolOccupationList.forEach((element) => {
        if (element.code == obj.occupation) {
          obj.showType = element.orderNum;
        }
      });
      let polyline = obj.areaTraceList.map((element, index) => {
        return {
          name: obj.name + "_" + obj.occupationDict,
          id: index,
          poiType: obj.showType,
          showMovePoint: true,
          showType: 3,
          info: {
            color: "",
            width: 12,
          },
          location: JSON.parse(element.coordinate),
          click: (e) => {},
        };
      });
      mapRef.value && mapRef.value.mapMoveAddLine(polyline);
    };
    //地图路径播放
    const mapMoveLineOpenClose = () => {
      state.mapMoveLineOpen = !state.mapMoveLineOpen;
      if (state.mapMoveLineOpen) {
        playReportList();
        //有人员轨迹数据才开始停止
        if (state.areaTraceList.length > 0) {
          mapRef.value && mapRef.value.mapStartMoveAddLine();
        }
      } else {
        clearInterval(state.playReport);
        if (state.areaTraceList.length > 0) {
          mapRef.value && mapRef.value.mapStopMoveAddLine();
        }
      }
    };
    const clearAreaTrace = () => {
      mapRef.value && mapRef.value.clearMoveAddLine();
    };
    //地图路径播放退出
    const stopPlay = () => {
      state.showOpenMoveLine = false;
      state.isPlay = false;
      state.reporterIndex = 0;
      clearInterval(state.playReport);
      state.playReport = null;
      clearAreaTrace();
      handleMapLineNodeArr(state.reporterList);
    };
    const openMapReport = (value, index) => {
      if (!value.handleCoordinate) {
        ElMessage({
          type: "warning",
          message: "暂无上报点位信息",
        });
        return;
      }
      mapRef.value && mapRef.value.clearPoint();
      state.reportDetials.forEach((item, ind) => {
        if (ind == index) {
          item.color = "#0bbd87";
        } else {
          item.color = "#666";
        }
      });
      setTimeout(() => {
        // 地图显示点
        pushPoint(value);
        // 地图定位
        const position = JSON.parse(value.handleCoordinate);
        mapRef.value && mapRef.value.mapLocation(position, 14.5);
      }, 200);
    };
    onUnmounted(() => {
      clearInterval(state.playReport);
      state.playReport = null;
      state.reporterIndex = 0;
      clearAreaTrace();
    });
    return {
      ...toRefs(state),
      formRef,
      mapRef,
      changeFile,
      loadMap,
      mapReportOpenClose,
      fileIdSrc,
      clickImg,
      mapMoveLineOpenClose,
      stopPlay,
      openMapReport,
    };
  },
});
</script>
<style lang="scss" scoped>
.taskListDetail {
  width: 100%;
  height: 70vh;
  font-size: 16px;
  overflow: auto;
  display: flex;
  flex-direction: row;
  .detial {
    height: 100%;
    width: 45%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .title {
      font-weight: 700;
      border-left: 3px solid #3a74fb;
      padding-left: 6px;
      span {
        margin-left: 12px;
        cursor: pointer;
      }
    }
    .detialLeft {
      width: 100%;
      // height: 30%;
      .el-row {
        width: 100%;
        margin-bottom: 24px;
      }
    }
    .detialRight {
      width: 100%;
      // height: 60%;
      .reportDetial {
        height: calc(100% - 20px);

        margin-top: 8px;
      }
      .detailInfo {
        height: 38px;
        @include flex-row-sb-c;
        margin-right: 15px;
      }
      .source {
        @include flex-row-sb-c;
        flex-wrap: wrap;
        padding: 0px 8px;
        .source_item {
          width: 100%;
          min-height: 150px;
          @include flex-row-sb-c;
          flex-wrap: wrap;
        }
        img {
          width: 150px;
          height: 100px;
          margin: 15px 12px;
        }
        video {
          width: 250px;
          height: 100px;
          margin: 15px 12px;
        }
        audio {
          width: 150px;
          height: 100px;
          margin: 15px 12px;
        }
      }
    }
    .reportDetial {
      width: 100%;
      padding: 0 12px;
      .source {
        @include flex-row-sb-c;
        flex-wrap: wrap;
        padding: 0px 8px;
        .source_item {
          width: 100%;
          min-height: 150px;
          @include flex-row-sb-c;
          flex-wrap: wrap;
        }
        img {
          width: 150px;
          height: 100px;
          margin: 15px 12px;
        }
        video {
          width: 250px;
          height: 100px;
          margin: 15px 12px;
        }
        audio {
          width: 150px;
          height: 100px;
          margin: 15px 12px;
        }
      }
    }
  }
  .mymap {
    height: 100%;
    width: 55%;
    padding-top: 12px;
  }
  .openLine {
    position: absolute;
    bottom: 20px;
    right: 30px;
    z-index: 10;
    width: 200px;
    height: 40px;
    padding: 0 8px;
    border: 1px solid #00a8ec;
    border-radius: 20px;
    background-color: rgba(45, 60, 93, 0.8);
    color: #fff;
    @include flex-row-sa-c;
    span {
      cursor: pointer;
    }
  }
}
</style>
